import { render, staticRenderFns } from "./HomeServiceTypeEmployeesNumber.vue?vue&type=template&id=3a1b0233&scoped=true&"
import script from "./HomeServiceTypeEmployeesNumber.vue?vue&type=script&lang=js&"
export * from "./HomeServiceTypeEmployeesNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1b0233",
  null
  
)

export default component.exports